module.exports = __webpack_public_path__ + "img/launch.5f0de563.jpg";